import { getRouteApi, useNavigate } from '@tanstack/react-router';
import * as React from 'react';

import { LegalEntityClientProvider } from '@/api/legal-entity-client-context';
import { LegalEntityHierarchyScreen } from '@/routes/admin/suppliers/legal-entity-hierarchy-screen';

// =============================================================================
// legal-entity-hierarchy-route.tsx — Adaptateur routeur de l'écran hiérarchie (T7-MULTI-ETAB).
// =============================================================================
// Le SIREN est le path param d'URL (« /admin/legal-entities/$siren ») — ressource d'URL,
// server-set côté back (validé `^\d{9}$`). Segment top-level DISTINCT de `/admin/suppliers/*`
// (aucune interaction avec le ranking `$siret` vs `new` — plan ARCH §2.2).
//
// Le BC hiérarchie AUTO-PORTE son DI seam : la route enveloppe l'écran avec le
// LegalEntityClientProvider local (défaut = HTTP réel) plutôt que de brancher le client dans
// providers.tsx global (disjonction T7 ∥ T6 — parité ParticipationsClientProvider).
//
// Navigation (LECTURE SEULE) : ouverture d'un SIRET → fiche A-04 (« /admin/suppliers/$siret ») ;
// retour → registre (« /admin/suppliers »). Le composant de présentation reste testable hors routeur.

const routeApi = getRouteApi('/admin/legal-entities/$siren');

export function LegalEntityHierarchyRoute(): React.JSX.Element {
  const { siren } = routeApi.useParams();
  const navigate = useNavigate();

  const onOpen = React.useCallback(
    (siret: string): void => {
      void navigate({ to: '/admin/suppliers/$siret', params: { siret } });
    },
    [navigate],
  );

  const onBack = React.useCallback((): void => {
    void navigate({ to: '/admin/suppliers' });
  }, [navigate]);

  return (
    <LegalEntityClientProvider>
      <LegalEntityHierarchyScreen siren={siren} onOpen={onOpen} onBack={onBack} />
    </LegalEntityClientProvider>
  );
}
